import { Link } from "react-router-dom";
import { Clock, ShieldCheck, Award, Gem, HeartHandshake, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { WHY_US } from "../data/content";

const ICONS = { Clock, ShieldCheck, Award, Gem, HeartHandshake };

export default function WhyUs() {
  return (
    <section className="mx-auto max-w-7xl px-5 md:px-10 py-24" data-testid="home-why-us">
      <Reveal>
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <Overline>The Speedy Difference</Overline>
            <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl tracking-tight">
              WHY SPEEDY RESURFACING, <span className="text-neon">NOT THE REST.</span>
            </h2>
          </div>
          <Link to="/quote" data-testid="whyus-quote" className="inline-flex items-center gap-1 text-neon hover:text-neon-hover font-medium">
            Start your project <ArrowRight size={16} />
          </Link>
        </div>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {WHY_US.map((w, i) => {
          const Icon = ICONS[w.icon];
          return (
            <Reveal key={w.title} delay={(i % 3) * 0.06}>
              <div data-testid={`whyus-${i}`} className="group h-full rounded-lg border border-white/10 bg-obsidian-800 p-7 hover:border-neon/40 transition-colors">
                <span className="flex h-12 w-12 items-center justify-center rounded-sm bg-neon/10 text-neon group-hover:bg-neon group-hover:text-obsidian transition-colors"><Icon size={24} /></span>
                <h3 className="mt-6 font-heading font-bold text-xl">{w.title}</h3>
                <p className="mt-2 text-sm text-zinc-300">{w.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
